import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Container, ActionHeader, ActionContent, HeaderToggle, HeaderToggleWrapper } from './DiscountCodeDetailExpandableItem.styles';

const DiscountCodeDetailExpandableItem = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [shouldTransition, setShouldTransition] = useState(false);
  const [height, setHeight] = useState(0);

  const contentEl = React.createRef();

  useEffect(() => {
    if (!contentEl.current || height !== 0) {
      return;
    }

    const computedHeight = window.getComputedStyle(contentEl.current).height;
    setHeight(computedHeight);

    setIsOpen(false);
    setShouldTransition(true);
  }, [contentEl, height]);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Container data-cy="discount-code-detail">
      <ActionHeader onClick={toggle}>
        <HeaderToggleWrapper>
          <HeaderToggle isExpanded={isOpen} />
        </HeaderToggleWrapper>
        <div data-cy="discount-code-detail-title">
          <FormattedMessage id={title} />
        </div>
      </ActionHeader>

      <ActionContent height={height} shouldTransition={shouldTransition} isExpanded={isOpen} ref={contentEl}>
        {children}
      </ActionContent>
    </Container>
  );
};

DiscountCodeDetailExpandableItem.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default DiscountCodeDetailExpandableItem;
